@switch (type) {
  @case ('cards') {
    <ng-container [ngTemplateOutlet]="CardsLoader"></ng-container>
  }
  @case ('lists') {
    <ng-container [ngTemplateOutlet]="ListLoader"></ng-container>
  }
  @case ('littleCards') {
    <ng-container [ngTemplateOutlet]="LittleCardsLoader"></ng-container>
  }
  @case ('littleList') {
    <ng-container [ngTemplateOutlet]="LittleList"></ng-container>
  }
  @default {
    <ng-container [ngTemplateOutlet]="DefaultLoader"></ng-container>
  }
}

<ng-template #CardsLoader>
  <div class="card">
    <div class="card-title skeleton"></div>
    <div class="card-body">
      <div class="items">
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
      <div class="item-graph skeleton"></div>
    </div>
  </div>
</ng-template>

<ng-template #LittleCardsLoader>
  <div class="card">
    <div class="card-title skeleton"></div>
    <div class="little-card-body skeleton"></div>
  </div>
</ng-template>

<ng-template #ListLoader>
  <div class="card card-list-parent">
    <div class="card-list skeleton"></div>
    <div class="card-list skeleton"></div>
    <div class="card-list skeleton"></div>
  </div>
</ng-template>

<ng-template #LittleList>
  <div class="card card-little-list-parent">
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
    <div class="card-little-list skeleton"></div>
  </div>
</ng-template>

<ng-template #DefaultLoader>
  <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  @if (text) {
    <span class="e-text method-1">{{ text }}</span>
  }
</ng-template>
